<template>
  <div class="main">
    <van-form @submit="onSubmit">
      <div class="panel">
        <van-field label-class="label" v-model="mdl.remark" name="经纪人ID" label="经纪人ID" placeholder="请输入经纪人ID" required
          errmsg="" :autofocus="true" :rules="[{ required: true }]" />
        <van-field label-class="label" name="到站类型" label="到站类型" required errmsg="" :rules="[{ required: true }]">
          <template #input>
            <van-radio-group v-model="mdl.orderType" direction="horizontal">
              <van-radio :name="1" :value="1">自驾到站</van-radio>
              <van-radio :name="2" :value="2">代驾代办</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field label-class="label" v-model="mdl.plateNum" name="车牌号" label="车牌号" placeholder="请输入车牌号" required
          errmsg="" :rules="[{ required: true }]" />
        <van-field label-class="label" v-model="mdl.contactName" name="客户姓名" label="客户姓名" placeholder="请输入客户姓名" required
          errmsg="" :rules="[{ required: true }]" />
        <van-field label-class="label" v-model="mdl.contactPhone" name="联系电话" label="联系电话" placeholder="请输入联系电话" />
        <van-field label-class="label" v-model="mdl.siteName" name="预约门店" label="预约门店" placeholder="请输入站点关键字模糊搜索"
          required errmsg="" :rules="[{ required: true }]">
          <template #button>
            <a @click="searchShop" style="color: #1989fa">搜索</a>
          </template>
        </van-field>
        <van-field label-class="label" v-model="mdl.reserveTime" name="预约" label="预约时间" placeholder="请选择预约时间" required
          arrow-direction="down" :is-link="true" errmsg="" readonly @click="showDay = true"
          :rules="[{ required: true }]">
        </van-field>
        <van-field label-class="label" v-if="mdl.orderType == 2" v-model="mdl.pickUpAddress" name="取车地点" label="取车地点"
          placeholder="请输入取车地点" required errmsg="" :rules="[{ required: true }]" />
        <van-field label-class="label" v-if="mdl.orderType == 2" v-model="mdl.pickUpDateString" name="取车时间" label="取车时间"
          placeholder="请选择取车时间" required arrow-direction="down" :is-link="true" errmsg="" @click="showPickUp = true"
          :rules="[{ required: true }]" />
        <van-field label-class="label" v-model="mdl.inspectionFees" name="检测费" label="检测费" placeholder="请输入检测费"
          type="number" required errmsg="" @input="computeTotalPrice" :rules="[{ required: true }]" />
        <van-field label-class="label" v-if="mdl.orderType == 2" v-model="mdl.consumption" name="代驾费" label="代驾费"
          placeholder="请输入代驾费" type="number" required errmsg="" @input="computeTotalPrice"
          :rules="[{ required: true }]" />
        <van-field label-class="label" v-model="mdl.totalPrice" name="订单总金额" label="订单总金额" required readonly />
      </div>
      <div class="panel">
        <van-field label-class="label" v-model="mdl.carTypeString" name="车辆类型" label="车辆类型" placeholder="请选择车辆类型"
          arrow-direction="down" :is-link="true" @click="showCarType = true" />
        <van-field label-class="label" v-model="mdl.vehicleType" name="燃油类型" label="燃油类型" placeholder="请选择燃油类型"
          arrow-direction="down" :is-link="true" @click="showFuelType = true" />
        <van-field label-class="label" v-model="mdl.carNature4Use" name="使用性质" label="使用性质" placeholder="请选择使用性质"
          arrow-direction="down" :is-link="true" @click="showcarNature4Use = true" />
        <van-field label-class="label" v-model="mdl.registerDate" name="注册日期" label="注册日期" placeholder="请选择注册日期"
          arrow-direction="down" :is-link="true" @click="showRegisterDate = true" />
        <van-field label-class="label" v-model="mdl.carAge" name="车龄" label="车龄" type="number" readonly
          placeholder="请输入车龄" />
        <van-field label-class="label" v-model="mdl.vin" name="车架号" label="车架号" placeholder="请输入车架号" />
        <van-field label-class="label" v-model="mdl.engineNum" name="发动机号" label="发动机号" placeholder="请输入发动机号" />
        <van-field label-class="label" v-model="mdl.idCardType" name="车主证件类型" label="车主证件类型" placeholder="请选择车主证件类型"
          arrow-direction="down" :is-link="true" @click="showIdCardType = true" />
        <van-field label-class="label" v-model="mdl.idCard" name="车主证件号码" label="车主证件号码" placeholder="请输入车主证件号码" />
      </div>
      <van-button class="bottomBtn" round block type="info" native-type="submit" :loading="submitLoading"
        v-if="showBtn">立即提交</van-button>
    </van-form>
    <van-popup v-model="showShop" position="bottom">
      <van-picker show-toolbar :loading="shopLoading" title="预约门店" value-key="value" :columns="shopColumns"
        @confirm="shopConfirm" @cancel="showShop = false" />
    </van-popup>
    <van-calendar v-model="showDay" @confirm="onDayConfirm" color="#1989fa" />
    <van-popup v-model="showPickUp" position="bottom">
      <van-datetime-picker @confirm="pickUpConfirm" type="datehour" title="取车时间" :min-date="minDate" />
    </van-popup>
    <van-popup v-model="showDate" position="bottom">
      <van-picker show-toolbar :loading="shopLoading" title="预约时间段" :columns="dateColumns" @confirm="dateConfirm"
        @cancel="showShop = false" />
    </van-popup>
    <van-popup v-model="showPickUp" position="bottom">
      <van-datetime-picker @confirm="pickUpConfirm" type="datehour" title="取车时间" :min-date="minDate" />
    </van-popup>
    <van-popup v-model="showCarType" position="bottom">
      <van-picker show-toolbar title="车辆类型" :columns="car" @confirm="carConfirm" @cancel="showCarType = false" />
    </van-popup>
    <van-popup v-model="showFuelType" position="bottom">
      <van-picker show-toolbar title="燃油类型" :columns="fuel" @confirm="fuelConfirm" @cancel="showFuelType = false" />
    </van-popup>
    <van-popup v-model="showcarNature4Use" position="bottom">
      <van-picker show-toolbar title="使用性质" :columns="carNature" @confirm="carNatureConfirm"
        @cancel="showcarNature4Use = false" />
    </van-popup>
    <van-popup v-model="showRegisterDate" position="bottom">
      <van-datetime-picker @confirm="registerDateConfirm" type="date" title="选择注册日期" :min-date="registerMinDate" />
    </van-popup>
    <van-popup v-model="showIdCardType" position="bottom">
      <van-picker show-toolbar title="车主证件类型" :columns="idCardType" @confirm="idCardTypeConfirm"
        @cancel="showIdCardType = false" />
    </van-popup>
    <van-overlay :show="showOverlay">
      <div>
        <div class="title">长按图片保存</div>
        <img :src="payImg" class="imgClass" />
        <div class="btnpanel">
          <van-button round type="info" @click="downloadBase64Image">继续添加</van-button>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import moment from "moment";
import { Notify } from "vant";
import { Toast } from "vant";
import { Dialog } from "vant";
export default {
  name: "HelloWorld",
  data() {
    return {
      mdl: {
        orderType: 1,
        inspectionFees: 298,
        totalPrice: 298,
        siteName: "",
        reserveTime: "",
        consumption: 0,
        carTypeString: "小型轿车",
        vehicleType: "汽油、混动",
        carNature4Use: "非营运",
      },
      minDate: new Date(),
      showPickUp: false,
      dayString: "",
      showRegisterDate: false,
      showcarNature4Use: false,
      showCarType: false,
      showFuelType: false,
      showDay: false,
      showDate: false,
      dateColumns: ["8:00-12:00", "14:00-17:30"],
      shopLoading: false,
      showShop: false,
      showIdCardType: false,
      car: ["小型轿车", "小型货车"],
      fuel: ["汽油、混动", "纯电动"],
      carNature: ["非营运", "营运"],
      idCardType: [
        "身份证",
        "组织机构代码",
        "统一社会信用代码",
        "境外人员身份证明",
      ],
      shopColumns: [
        {
          value: "",
        },
      ],
      payImg: "",
      showOverlay: false,
      url: "https://www.jindishop.cn/cheshiwuyouapi/api/phone/",
      //url: "https://localhost:44314/api/phone/",
      scan: "https://www.jindishop.cn/cheshiwuyouapi/api/admin/BuildScanCode/",
      submitLoading: false,
      showBtn: true,
      registerMinDate: new Date(2000, 0, 1),
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    inputSiteName(e) {
      console.log(e)
      this.mdl.siteName = e.detail
    },
    handleResize() {
      this.showBtn = window.innerHeight > 500;
    },
    idCardTypeConfirm(value) {
      this.mdl.idCardType = value;
      this.showIdCardType = false;
    },
    computeTotalPrice() {
      this.mdl.totalPrice =
        parseFloat(this.mdl.inspectionFees) +
        parseFloat(this.mdl.consumption) || 0;
    },
    registerDateConfirm(value) {
      this.mdl.registerDate = moment(value).format("YYYY-MM-DD");
      this.mdl.carAge = moment().diff(moment(value), "years");
      this.showRegisterDate = false;
    },
    carNatureConfirm(value) {
      this.mdl.carNature4Use = value;
      this.showcarNature4Use = false;
    },
    carConfirm(value) {
      this.mdl.carType = value;
      this.showCarType = false;
    },
    fuelConfirm(value) {
      this.mdl.vehicleType = value;
      this.showFuelType = false;
    },
    pickUpConfirm(value) {
      this.mdl.pickUpDateString = moment(value).format("YYYY-MM-DD HH") + "点";
      this.showPickUp = false;
    },
    onSubmit() {
      let that = this;
      console.log(this.mdl)
      const reg = /^1\d{10}$/;
      if (!reg.test(this.mdl.remark)) {
        return;
      }
      if (this.submitLoading) {
        return;
      }
      this.submitLoading = true;
      this.mdl.inspectionFees = parseFloat(this.mdl.inspectionFees);
      this.mdl.consumption = parseFloat(this.mdl.consumption);
      this.mdl.totalPrice = parseFloat(this.mdl.totalPrice);
      this.mdl.carType = this.mdl.carTypeString == "小型轿车" ? 1 : 2;
      if (this.mdl.carAge) {
        this.mdl.carAge = parseInt(this.mdl.carAge);
      }
      this.$axios
        .post(this.url + "SubmitOrder", this.mdl)
        .then((res) => {
          if (res.data.status == 200) {
            Notify({ type: "success", message: "提交成功" });
            let loading = Toast.loading({
              message: "生成支付码...",
              forbidClick: true,
            });
            this.$axios
              .get(this.scan + res.data.data)
              .then((res1) => {
                if (res1.data.status == 200) {
                  that.payImg = res1.data.data;
                  that.showOverlay = true;
                } else {
                  Notify({ type: "danger", message: res1.data.msg });
                }
              })
              .finally(() => {
                loading.clear();
              });
          } else {
            if (res.data.msg && res.data.msg != "") {
              Notify({ type: "danger", message: res.data.msg });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    shopConfirm(value) {
      this.mdl.siteName = value;
      this.showShop = false;
    },
    onDayConfirm(value) {
      this.dayString = moment(value).format("YYYY-MM-DD");
      this.showDay = false;
      this.showDate = true;
    },
    dateConfirm(value) {
      this.mdl.reserveTime = this.dayString + " " + value;
      this.showDate = false;
    },
    searchShop() {
      let that = this;
      if (this.mdl.siteName != "") {
        this.showShop = true;
        this.shopLoading = true;
        this.$axios
          .get(this.url + "SiteSelect?all=0&key=" + this.mdl.siteName)
          .then(function (response) {
            that.shopColumns = response.data.data;
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(() => {
            that.shopLoading = false;
          });
      }
    },
    downloadBase64Image() {
      Dialog.confirm({
        message: "确认已保存支付码，继续添加？",
      })
        .then(() => {
          let remark = this.mdl.remark;
          this.mdl = {
            orderType: 1,
            inspectionFees: 298,
            totalPrice: 298,
            siteName: "",
            reserveTime: "",
            consumption: 0,
            carTypeString: "小型轿车",
            vehicleType: "汽油、混动",
            carNature4Use: "非营运",
            remark: remark,
          };
          this.showOverlay = false;
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.van-cell {
  font-size: 16px;
}

.main {
  height: calc(100vh - 100px);
  overflow: auto;
  position: relative;
  padding-bottom: 100px;
  box-sizing: border-box;
}

.panel {
  border-radius: 4px;
  box-sizing: border-box;
  padding: 10px;
}

.bottomBtn {
  position: fixed;
  bottom: 0;
  width: 100%;
  right: 0;
  border-radius: 4px;
  font-size: 17px;
  font-weight: 600;
}

.panel>div {
  border-radius: 4px;
}

.imgClass {
  width: 94%;
  margin-top: 30px;
  border-radius: 4px;
}

.btnpanel {
  width: 100%;
  display: flex;
  margin-top: 40px;
}

.title {
  text-align: center;
  font-size: 16px;
  margin-top: 40px;
  color: white;
}

.btnpanel button {
  width: 90%;
  margin: 0 auto;
}
</style>
